// extracted by mini-css-extract-plugin
export var childrenContainer = "_bm-0";